import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MedicalDataMap } from "app/shared/types";

@Component({
	selector: "medical-data-list",
	templateUrl: "overview-list.component.html",
	styleUrls: ["overview-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class OverviewListComponent {
	private translateService = inject(TranslateService);

	// @ts-expect-error TS2564
	@Input() data: MedicalDataMap;
	@Output() selectMedicalData = new EventEmitter<string>();

	private readonly supportedDataTypes = [
		"blood_pressure",
		"blood_glucose",
		"spo2",
		"weight",
		"temperature",
		"faeces",
		"heart-rate",
		"diuresis",
	];

	protected medicalParameters = this.supportedDataTypes
		.map((dataType) => {
			return {
				dataType,
				title: this.translateService.instant(`medical_data.types.${dataType}.name`),
			};
		})
		.sort((a, b) => a.title.localeCompare(b.title));
}
